import { createSelector } from 'reselect';
import * as accountSelectors from 'data/accounts/selectors';
import { Map as ImmutableMap } from 'immutable';

import { INVESTMENT_BALANCES_V2_REDUCER_KEY } from './investmentBalancesV2Reducer';

export const getResourceStore = (state) => state[INVESTMENT_BALANCES_V2_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const isLoading = (state) => getResourceStore(state).isLoading;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
export const getInvestmentBalances = (state) => getResourceStore(state).resourcesById;

export const getLatestBalancesByAccountId = createSelector(
  getInvestmentBalances,
  (balances) => ImmutableMap().withMutations((latestBalancesByAccountId) => balances.forEach((balance) => {
    const latestBalance = latestBalancesByAccountId.get(balance.accountId);
    if (!latestBalance || latestBalance.balanceOn < balance.balanceOn) {
      latestBalancesByAccountId.set(balance.accountId, balance);
    }
  })),
);

export const getBalanceTotalsForAccounts = createSelector(
  getLatestBalancesByAccountId,
  (state, accounts) => accountSelectors.accountIds(state, accounts),
  (balances, accountIds) => balances
    .filter((balance) => !accountIds || accountIds.has(balance.accountId))
    .reduce((accumulator, balance) => {
      accumulator.cashBalance = typeof accumulator.cashBalance === 'number' ?
        accumulator.cashBalance + (balance.cashBalance || 0) : balance.cashBalance;
      accumulator.balance = typeof accumulator.balance === 'number' ?
        accumulator.balance + (balance.balance || 0) : balance.balance;
      return accumulator;
    }, {
      balance: 0,
      cashBalance: 0,
    }),
);

export const getBalance = createSelector(
  getInvestmentBalances,
  (state, accounts) => accounts || accountSelectors.getInvestmentAccounts(state),
  (balances, accounts) => accounts.reduce((totalBalance, account) => {
    const resultBalance = balances
      .filter((balance) => balance.accountId === account.id)
      .sort((balance1, balance2) => balance1.balanceOn.localeCompare(balance2.balanceOn))
      .last();
    return totalBalance + (resultBalance ? resultBalance.balance : 0);
  }, 0),
);
